<template>
  <div v-if="customer">
    <BRow v-if="!hideTitle">
      <BCol>
        <BRow>
          <BCol sm="7" cols="12">
            <h2 v-if="isClaim && !isTicketFieldsAsked">{{ $t('customer_form_click_on_claim_button') }}</h2>
            <h2 v-else>{{ $t('customer_form_title') }}</h2>
          </BCol>
          <BCol v-if="isClaim && isTicketFieldsAsked && orderCustomer" sm="5" cols="12" id="copy-data-link">
            <a @click="copyOrderCustomer" href="javascript:">{{ $t('ticket_claim_copy_order_data') }}</a>
          </BCol>
        </BRow>
        <span v-if="message">{{ message }}<br><br></span>
      </BCol>
    </BRow>
    <BRow>
      <BCol v-if="customerFields.indexOf('company_name') !== -1">
        <MaterialInput v-model="customer.company_name"
                       :label="(mandatoryFields.indexOf('company_name') !== -1) ? $t('customer_company_name') + '*' : $t('customer_company_name')"
                       :state="validated ? errors.indexOf('company_name') === -1 : null"
                       @input="$emit('change')"
                       @change="reValidate()"
        />
      </BCol>
    </BRow>
    <BRow>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('first_name') !== -1">
        <MaterialInput v-model="customer.first_name"
                       :label="(mandatoryFields.indexOf('first_name') !== -1) ? $t('customer_first_name') + '*' : $t('customer_first_name')"
                       :state="validated ? errors.indexOf('first_name') === -1 : null"
                       @input="$emit('change')"
                       @change="reValidate()"
        >
          <template #icon>
            <!-- SVG icon -->
            <svg xmlns="http://www.w3.org/2000/svg" width="20.933" height="23.668" viewBox="0 0 20.933 23.668">
              <g id="Icon_akar-person" data-name="Icon akar-person" transform="translate(-3.895 -2)">
                <path id="Path_152" data-name="Path 152" d="M21.334,8.417A5.417,5.417,0,1,1,15.917,3a5.417,5.417,0,0,1,5.417,5.417Z" transform="translate(-1.556)" fill="none" stroke="#0a2336" stroke-width="2"/>
                <path id="Path_153" data-name="Path 153" d="M19.778,21h.381a3.25,3.25,0,0,1,3.224,2.847l.424,3.384a2.167,2.167,0,0,1-2.151,2.435H7.066a2.167,2.167,0,0,1-2.151-2.435l.423-3.384A3.25,3.25,0,0,1,8.564,21h.38" transform="translate(0 -4.999)" fill="none" stroke="#0a2336" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </g>
            </svg>
          </template>
        </MaterialInput>
      </BCol>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('last_name') !== -1">
        <MaterialInput v-model="customer.last_name"
                       :label="(mandatoryFields.indexOf('last_name') !== -1) ? $t('customer_last_name') + '*' : $t('customer_last_name')"
                       :state="validated ? errors.indexOf('last_name') === -1 : null"
                       @input="$emit('change')"
                       @change="reValidate()"
        >
          <template #icon>
            <!-- SVG icon -->
            <svg xmlns="http://www.w3.org/2000/svg" width="20.933" height="23.668" viewBox="0 0 20.933 23.668">
              <g id="Icon_akar-person" data-name="Icon akar-person" transform="translate(-3.895 -2)">
                <path id="Path_152" data-name="Path 152" d="M21.334,8.417A5.417,5.417,0,1,1,15.917,3a5.417,5.417,0,0,1,5.417,5.417Z" transform="translate(-1.556)" fill="none" stroke="#0a2336" stroke-width="2"/>
                <path id="Path_153" data-name="Path 153" d="M19.778,21h.381a3.25,3.25,0,0,1,3.224,2.847l.424,3.384a2.167,2.167,0,0,1-2.151,2.435H7.066a2.167,2.167,0,0,1-2.151-2.435l.423-3.384A3.25,3.25,0,0,1,8.564,21h.38" transform="translate(0 -4.999)" fill="none" stroke="#0a2336" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </g>
            </svg>
          </template>
        </MaterialInput>
      </BCol>
    </BRow>
    <BRow v-if="customerFields.indexOf('address') !== -1">
      <BCol sm="12" md="6">
        <MaterialInput v-model="customer.address"
                       :label="(mandatoryFields.indexOf('address') !== -1) ? $t('customer_address') + '*' : $t('customer_address')"
                       :state="validated ? errors.indexOf('address') === -1 : null"
                       :disabled="disabled"
                       @input="$emit('change')"
                       @change="reValidate()"
        />
      </BCol>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('address') !== -1">
        <MaterialInput v-model="customer.house_nr"
                       :label="(mandatoryFields.indexOf('address') !== -1) ? $t('customer_house_nr') + '*' : $t('customer_house_nr')"
                       :state="validated ? errors.indexOf('address') === -1 : null"
                       :disabled="disabled"
                       @input="$emit('change')"
                       @change="reValidate()"
        />
      </BCol>
    </BRow>
    <BRow>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('zip') !== -1">
        <MaterialInput v-model="customer.zip"
                       :label="(mandatoryFields.indexOf('zip') !== -1) ? $t('customer_zip') + '*' : $t('customer_zip')"
                       :state="validated ? errors.indexOf('zip') === -1 : null"
                       :disabled="disabled"
                       @input="$emit('change')"
                       @change="reValidate()"
        />
      </BCol>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('city') !== -1">
        <MaterialInput v-model="customer.city"
                       :label="(mandatoryFields.indexOf('city') !== -1) ? $t('customer_city') + '*' : $t('customer_city')"
                       :state="validated ? errors.indexOf('city') === -1 : null"
                       :disabled="disabled"
                       @input="$emit('change')"
                       @change="reValidate()"
        />
      </BCol>
    </BRow>
    <BRow>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('phone') !== -1">
        <MaterialInput v-model="customer.phone"
                       :label="(mandatoryFields.indexOf('phone') !== -1) ? $t('customer_phone') + '*' : $t('customer_phone')"
                       :state="validated ? errors.indexOf('phone') === -1 : null"
                       :disabled="disabled"
                       @input="$emit('change')"
                       @change="reValidate()"/>
      </BCol>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('country') !== -1">
        <BFormGroup
            :label="(mandatoryFields.indexOf('country') !== -1) ? $t('customer_country') + '*' : $t('customer_country')">
          <BFormSelect text-field="label" value-field="id" :options="countries" :disabled="disabled"
                       v-model="customer.country"
                       @change="reValidate()"
                       :state="validated ? errors.indexOf('country') === -1 : null">
          </BFormSelect>
        </BFormGroup>
      </BCol>
    </BRow>
    <BRow>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('gender') !== -1">
        <BFormGroup
            :label="(mandatoryFields.indexOf('gender') !== -1) ? $t('customer_gender') + '*' : $t('customer_gender')">
          <BFormRadioGroup :options="genders"
                           :disabled="disabled" v-model="customer.gender"
                           @change="reValidate()"
                           :state="validated ? errors.indexOf('gender') === -1 : null">
            <BFormInvalidFeedback :state="validated ? errors.indexOf('gender') === -1 : null">
              {{ $t('errors_please_select') }}
            </BFormInvalidFeedback>
          </BFormRadioGroup>
        </BFormGroup>
      </BCol>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('dob') !== -1">
        <BFormGroup
            :label="(mandatoryFields.indexOf('dob') !== -1) ? $t('customer_dob') + '* (' + $t('date_format') + ')' : $t('customer_dob') + ' (' + $t('date_format') + ')'">
          <BFormSelect class="doBFormSelect day" text-field="label" value-field="id" :options="days" :disabled="disabled"
                        v-model="tmp_dob.day"
                        @change="reValidate()"
                        :state="validated ? errors.indexOf('dob') === -1 : null">
          </BFormSelect>
          <BFormSelect class="doBFormSelect month" text-field="label" value-field="id" :options="months" :disabled="disabled"
                        v-model="tmp_dob.month"
                        @change="reValidate()"
                        :state="validated ? errors.indexOf('dob') === -1 : null">
          </BFormSelect>
          <BFormSelect class="doBFormSelect year" text-field="label" value-field="id" :options="years" :disabled="disabled"
                        v-model="tmp_dob.year"
                        @change="reValidate()"
                        :state="validated ? errors.indexOf('dob') === -1 : null">
          </BFormSelect>
        </BFormGroup>
      </BCol>
    </BRow>
    <BRow>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('email') !== -1">
        <MaterialInput v-model="customer.email"
                       :label="(mandatoryFields.indexOf('email') !== -1) ? $t('customer_email') + '*' : $t('customer_email')"
                       :state="validated ? errors.indexOf('email') === -1 : null"
                       :disabled="disabled"
                       @input="$emit('change')"
                       @change="checkEmail()">
          <template #icon>
            <!-- SVG icon -->
            <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 512 512"><path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"/></svg>
          </template>
        </MaterialInput>
        <p v-if="emailSuggestion" class="mt-2">
          {{ $t('customer_email_suggestion', emailSuggestion) }}
          <BButton variant="success" size="xs" class="p-1"
                   @click="customer.email = emailSuggestion.full;emailSuggestion = null">
            {{ $t('yes') }}
          </BButton>
          <BButton variant="danger" size="xs" class="p-1 ms-2" @click="emailSuggestion = null">
            {{ $t('no') }}
          </BButton>
        </p>
      </BCol>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('email_confirmation') !== -1">
        <MaterialInput v-model="customer.email_confirmation"
                       :label="$t('email_confirmation') + (mandatoryFields.indexOf('email_confirmation') !== -1 ? '*' : '')"
                       :state="validated ? errors.indexOf('email_confirmation') === -1 : null"
                       :disabled="disabled"
                       @input="$emit('change')"
                       @change="checkEmail();$emit('change')"
                       @paste="onConfirmationPaste">
          <template #icon>
            <!-- SVG icon -->
            <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 512 512"><path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"/></svg>
          </template>
        </MaterialInput>
      </BCol>
    </BRow>
    <BRow>
      <BCol sm="12" md="6" v-if="customerFields.indexOf('optin') !== -1">
        <BFormGroup>
          <BFormCheckbox v-if="fields && fields[0] && fields[0].company_id == 33" :disabled="disabled" v-model="customer.optin">{{ $t('customer_optin_iams') }}
          </BFormCheckbox>
          <BFormCheckbox v-if="fields && fields[0] && fields[0].company_id != 33" :disabled="disabled" v-model="customer.optin">{{ $t('customer_optin') }}
          </BFormCheckbox>
        </BFormGroup>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import mailcheck from 'mailcheck'
import moment from 'moment'
import MaterialInput from '@/components/MaterialInput.vue'
import {
  BCol,
  BFormGroup,
  BFormInvalidFeedback,
  BFormRadioGroup,
  BRow,
  BFormSelect,
  BButton,
  BFormCheckbox
} from "bootstrap-vue-next";

export default {
  name: "CustomerForm",
  props: {
    modelValue: Object,
    fields: Array,
    level: String,
    disabled: Boolean,
    message: String,
    isClaim: Boolean,
    orderCustomer: Object,
    hideTitle: Boolean
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      errors: [],
      days: [],
      months: [],
      years: [],
      validated: false,
      countries: [
        {id: 'DE', label: this.$t('country_de')},
        {id: 'NL', label: this.$t('country_nl')},
        {id: 'ES', label: this.$t('country_es')},
        {id: 'BE', label: this.$t('country_be')},
      ],
      genders: [
        {value: 'm', text: this.$t('customer_gender_male')},
        {value: 'f', text: this.$t('customer_gender_female')},
        {value: 'o', text: this.$t('customer_gender_other')}
      ],
      customer: {},
      emailSuggestion: null,
      tmp_dob: {
        day: null,
        month: null,
        year: null
      },
      email_confirmation_error: false
    }
  },
  created(){
    for(let i=1;i<=31;i++){
      let a = i
      if(a.toString().length == 1){ a = '0' + a }
      this.days.push(a)
    }
    for(let i=1;i<=12;i++){
      let a = i
      if(a.toString().length == 1){ a = '0' + a }
      this.months.push(a)
    }
    for(let i=new Date().getFullYear();i>=new Date().getFullYear()-130;i--){
      this.years.push(i)
    }
  },
  methods: {
    formatDob(){
      if( this.customer && this.customer.dob ){
        let date = this.customer.dob.split(' ')[0].split('-')
        if(date){
          this.tmp_dob = {
            day: date[2],
            month: date[1],
            year: date[0]
          }
        }
      }
    },
    checkEmail() {
      this.customer.email = this.customer.email.trim()
      this.reValidate()
      mailcheck.run({
        email: this.customer.email,
        suggested: (suggestion) => {
          this.emailSuggestion = suggestion
        }
      })
    },
    validateDob(){
      if(!this.tmp_dob.day || !this.tmp_dob.month || !this.tmp_dob.year){
        this.errors.push('dob')
      }
      if(this.tmp_dob.day && this.tmp_dob.month && this.tmp_dob.year){
        this.customer.dob = this.tmp_dob.year + '-' + this.tmp_dob.month + '-' + this.tmp_dob.day
      }
      const date = `${this.tmp_dob.year}-${this.tmp_dob.month}-${this.tmp_dob.day}`;

      if(moment(moment().format('YYYY-MM-DD')).diff(date) <= 0) {
        this.errors.push('dob')
      }
    },
    validateEmail( email ){
      if(email == null){ return null }
      return email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    },
    validateCity(isMandatory) {
      if(!this.customer.city && isMandatory) {
        return null;
      }
      if(!this.customer.city){
        return
      }
      this.customer.city = this.customer.city[0].toUpperCase() + this.customer.city.slice(1).toLowerCase();
      return this.customer.city.match(/^[\p{So}\p{Mn}\p{P}\p{Z}À-ÿa-zA-Z]+$/u)
    },
    validate() {
      this.validated = true
      this.errors = []
      this.email_confirmation_error = false;
      this.fields.forEach(customerField => {
        let f = customerField.field
        if (!customerField.order_mandatory && this.level === 'order') {
          return
        }
        if (!customerField.ticket_mandatory && this.level === 'ticket') {
          return
        }

        if(this.customer[f]){
          this.customer[f] = typeof this.customer[f] === 'string' ? this.customer[f].trim() : this.customer[f]
        }

        if( f === 'dob' && this.tmp_dob.day || this.tmp_dob.month || this.tmp_dob.year ){
          this.validateDob()
        }

        if(f === 'city') {
          if (this.validateCity(customerField.order_mandatory && this.level === 'order') === null) {
            this.errors.push(f);
          }

          if (this.validateCity(customerField.ticket_mandatory && this.level === 'ticket') === null) {
            this.errors.push(f);
          }
        }
        if(f === 'dob'){
          this.validateDob()
        } else if (!this.customer[f] || !this.customer[f].length) {
          this.errors.push(f)
        } else {
          if (this.customer[f].length === 0) {
            this.errors.push(f)
          }
          else if (f === 'email') {
            if( this.validateEmail(this.customer[f]) === null){
              this.errors.push(f)
            }
          }
          else if(f === 'email_confirmation') {
            if( this.validateEmail(this.customer[f]) === null){
              this.errors.push(f)
            }
            if(this.customer.email && this.customer.email !== this.customer.email_confirmation) {
              this.email_confirmation_error = true;
              this.errors.push(f);
            }
          }
        }

      })
    },
    reValidate() {
      this.$emit('change');
      if (this.validated && !this.isValid) {
        this.validate()
      }
    },
    reset() {
      this.errors = []
      this.validated = false
    },
    isValid() {
      this.validate()
      const date = `${this.tmp_dob.year}-${this.tmp_dob.month}-${this.tmp_dob.day}`;

      if( this.tmp_dob.year && this.tmp_dob.month && this.tmp_dob.day && moment(moment().format('YYYY-MM-DD')).diff(date) <= 0) {
        this.$store.commit('errors', [this.$t('birth_date_must_be_past')])
        return
      }
      return this.validated && this.errors.length === 0
    },
    copyOrderCustomer() {
      if(!this.isClaim || !this.orderCustomer) {
        return;
      }
      for(const field of this.fields) {
        if(field.ticket_ask) {
          if(this.orderCustomer[field.field]) {
            this.customer[field.field] = this.orderCustomer[field.field]
          }
          else if(this.orderCustomer.address && this.orderCustomer.address[field.field]) {
            this.customer[field.field] = this.orderCustomer.address[field.field];
          }
          if(field.field === 'email') {
            this.checkEmail();
          }
        }
      }
      this.$forceUpdate();
    },
    onConfirmationPaste(e) {
      e.preventDefault();
    }
  },
  computed: {
    customerFields() {
      if (!this.fields) {
        return []
      }
      return this.fields.filter(customerField => {
        if (this.level === 'order') {
          return customerField.order_ask
        }
        if (this.level === 'ticket') {
          return customerField.ticket_ask
        }
        return false
      }).map((customerField) => {
        return customerField.field
      })
    },
    mandatoryFields() {
      if (!this.fields) {
        return []
      }
      return this.fields.filter(mandatoryField => {
        if (this.level === 'order' && mandatoryField.order_ask) {
          return mandatoryField.order_mandatory
        }
        if (this.level === 'ticket' && mandatoryField.ticket_ask) {
          return mandatoryField.ticket_mandatory
        }
        return false
      }).map((mandatoryField) => {
        return mandatoryField.field
      })
    },
    isTicketFieldsAsked() {
      return this.fields.some(f => f.ticket_ask);
    }
  },
  watch: {
    customer() {
      this.$emit('update:modelValue', this.customer)
    },
    modelValue() {
      this.customer = this.modelValue
      this.formatDob()
    },
    tmp_dob: {
      deep: true,
      handler () {
        if (this.tmp_dob.day && this.tmp_dob.month && this.tmp_dob.year) {
          this.customer.dob = this.tmp_dob.year + '-' + this.tmp_dob.month + '-' + this.tmp_dob.day
        } else {
          this.customer.dob = null
        }
      }
    }
  },
  mounted() {
    this.customer = this.modelValue
    this.formatDob()
  },
  components: {
    BFormCheckbox,
    BButton,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BFormGroup,
    BFormRadioGroup,
    BFormSelect,
    MaterialInput
  }
}
</script>
<style scoped lang="scss">
h2{
  font-size:1.5rem;
  font-weight:bold;
  margin-bottom:20px
}
#copy-data-link{
  text-align:right
}
.doBFormSelect{
  float:left
}
.doBFormSelect.day, .doBFormSelect.month{
  width:80px;
  margin-right:10px
}
.doBFormSelect.year{
  width:100px
}
@media screen and (max-width: 768px) {
  .doBFormSelect.day, .doBFormSelect.month{
    width:47%
  }
  .doBFormSelect.month{
    margin-right:0px
  }
  .doBFormSelect.year{
    width:100%
  }
  .doBFormSelect.day, .doBFormSelect.month{
    margin-bottom:10px
  }
}
@media screen and (max-width: 578px) {
  #copy-data-link{
    text-align:left;
    margin-bottom:15px
  }
}
@media screen and (max-width: 420px) {
  .doBFormSelect.day, .doBFormSelect.month{
    width:100%;
    margin-right:0
  }
}
</style>